<template>
    <div>
        <div :id="modalId" uk-modal class="mass-message-form">
            <div class="uk-modal-dialog uk-modal-body">
                <h2 class="uk-modal-title uk-margin-small-bottom">Mass Message</h2>
                <div v-if="this.filter" class="uk-align-right@m uk-margin-remove-bottom recipients">
                    All Filtered Recipients Selected
                </div>
                <div v-else-if="requisition" class="recipients uk-margin-small-bottom">
                    <div class="uk-grid">
                        <div class="uk-width-1-2">
                            <select class="uk-select" v-model="shiftId">
                                <option v-for="shift in shiftOptions" :value="shift.id" >{{shift.name}}</option>
                            </select>
                        </div>
                        <div class="uk-width-1-2 uk-text-right uk-text-bottom">
                            {{ ids.length }} Recipients Selected
                        </div>
                    </div>
                </div>
                <div v-else class="uk-align-right@m uk-margin-remove-bottom recipients">
                    {{ ids.length }} Recipients Selected
                </div>
                <div class="uk-clearfix"></div>
                <div style="margin-bottom: 15px;">
                    <label for="message-field" class="uk-form-label">Message Title </label>
                    <div class="uk-form-controls">
                        <input id="name-field" type="text" class="uk-input" name="group_name" v-model="messageName"></input>
                    </div>
                </div>
                <div>
                    <label for="message-field" class="uk-form-label header">Compose Message <span class="uk-align-right uk-margin-remove">{{ message.length }}/{{ messageMaxSize }}</span></label>
                    <div class="uk-form-controls">
                        <textarea id="message-field" class="uk-textarea bottom-border" v-model="message"></textarea>
                    </div>
                </div>
                <div class="uk-margin-medium-bottom"></div>
                <div v-if="displayWarning" class="warning-message uk-grid uk-grid-collapse">
                    <div class="uk-container-center">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="warning-message-text uk-width-5-6">
                        Warning. You have unfilled placements in this requisition.
                        Messages will only go to workers placed in a craft.
                    </div>
                </div>
                <div v-if="!sendingMessage" class="uk-align-right">
                    <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()"><i class="fas fa-times-circle"></i> Cancel</button>
                    <button class="uk-button uk-button-primary" type="button" @click="submitForm()"><i class="fas fa-comment fa-flip-horizontal"></i> Send Message</button>
                </div>
				<div v-else-if="sendingMessage" class="uk-align-right">
					<i class="fas fa-spinner fa-spin"></i> Sending Message...
				</div>
            </div>
        </div>
        <div :id="modalId+'_confirm'" uk-modal class="mass-message-form">
            <div class="uk-modal-dialog uk-modal-body">
                <h2 class="uk-modal-title uk-margin-medium-bottom">Message Sent</h2>

                <button class="uk-button uk-button-primary uk-modal-close" type="button"><i class="fas fa-grin-alt"></i> OK!</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MessageForm",

        props:{
            modalId:String,
            personIds:{type: Array, default:function(){return []}},
            requisitionId:{type: Number, default: 0}
        },

        data(){
            return {
                ids: [],
                filter: null,
                messageName:"",
                message: "",
                messageMaxSize:160,
                displayWarning: false,
                requisition: null,
                shiftId: 0,
                shiftOptions: [
                    {
                        id: 0,
                        name: "All Shifts"
                    }
                ],
				sendingMessage: false,
            }
        },

        mounted(){
            /*setRequisition called from an outside source.*/
        },

        methods:{
            submitForm(){
                if(this.ids.length > 0){
					this.sendingMessage = true;
                    axios.post("/api/message/send", {
                        person_ids: this.ids,
                        group_name: this.messageName,
                        message:this.message,
						requisition_id: this.requisition ? this.requisition.id:null,
                    }).then(() => this.showConfirmation())
						.catch(error => this.submitError(error));
                } else if (this.filter != null){
					this.sendingMessage = true;
                    axios.post("/api/message/send", {
                        filter: this.filter,
                        group_name: this.messageName,
                        message:this.message,
						requisition_id: this.requisition ? this.requisition.id:null,
                    }).then(() => this.showConfirmation())
						.catch(error => this.submitError(error));
                }
				else {
					this.submitError({response: {data: {message: "Nothing to send."}}});
				}

            },
            requisitionLoaded(pack){
                if(pack.data.success){
                    this.requisition = pack.data.data;
                }
            },
            showConfirmation(){
				this.sendingMessage = false;
                UIkit.modal("#"+this.modalId+"_confirm").show();
            },
			submitError(error){
				this.sendingMessage = false;
				let message = "Unable to send message.";
				if(error.response && error.response.data && error.response.data.message){
					message += ' ' + error.response.data.message;
					for(let i in error.response.data.errors){
						message += ' ' + error.response.data.errors[i];
					}
				}
				UIkit.notification({
					message: message,
					status: 'danger',
					pos: 'top-center',
					timeout: 5000
				});
			},
            setSendIds(arr){
                this.ids = arr;
                this.filter = null;
            },
            setRequisition(req){
                this.requisition = req;
                this.shiftOptions = [
                    {
                        id: 0,
                        name: "All Shifts"
                    }
                ];
                for(let i = 0; i < this.requisition.dates.length;++i){
                    this.shiftOptions.push({
                        id: this.requisition.dates[i].id,
                        name: this.requisition.dates[i].name
                    });
                }
                this.updateSendList();
            },
            updateSendList(){
                this.ids = [];
                if(this.shiftId == 0){
                    for(let i = 0; i < this.requisition.jobRequests.length; ++i){
                        let job = this.requisition.jobRequests[i];
                        for(let j = 0; j < job.placements.length; ++j){
                            this.ids.push(job.placements[j].person_id);
                        }
                    }
                } else {
                    for(let i = 0; i < this.requisition.jobRequests.length; ++i){
                        let job = this.requisition.jobRequests[i];
                        for(let j = 0; j < job.placements.length; ++j){
                            job.placements[j].requisition_date_id == this.shiftId ?
                            this.ids.push(job.placements[j].person_id):null;
                        }
                    }
                }

                if(this.requisition.manager && this.requisition.manager.person){
                    this.ids.push(this.requisition.manager.person.id);
                }

                if(this.requisition.contact && this.requisition.contact.person){
                    this.ids.push(this.requisition.contact.person.id);
                }
            },
            addSendId(id){
                this.ids.push(id);
                this.filter = null;
            },
            setFilterCriteria(filter){
                this.filter = filter;
                this.ids = [];
            },
            cancel(){
                this.message = "";
            }
        },

        watch:{
            message(){
                if(this.message.length > 160){
                    this.message = this.message.substring(0, this.messageMaxSize);
                }
                if(this.ids.length == 0){
                    this.updateSendList();
                }
            },
            shiftId(){
                this.updateSendList();
            }
        }
    }
</script>

<style scoped>

</style>
